module.exports = __webpack_public_path__ + "static/media/Alegreya-Medium.b6c38435.ttf";